/**
 * <upsell-carousel> — arrows for the "אולי תאהבו גם" scroll-snap track.
 * Scrolling itself is native (swipe, trackpad, keyboard); this only steps one
 * card per click and disables an arrow at its end. Works in RTL, where
 * scrollLeft runs from 0 down to negative values.
 */
if (!customElements.get('upsell-carousel')) {
  customElements.define(
    'upsell-carousel',
    class UpsellCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.upsell__track');
        this.nav = this.querySelector('.upsell__nav');
        this.prev = this.querySelector('[data-dir="prev"]');
        this.next = this.querySelector('[data-dir="next"]');
        if (!this.track || !this.nav || !this.prev || !this.next) return;

        this.onClick = (event) => this.step(event.currentTarget.dataset.dir === 'next' ? 1 : -1);
        this.onScroll = () => {
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => {
            this.frame = null;
            this.update();
          });
        };

        this.prev.addEventListener('click', this.onClick);
        this.next.addEventListener('click', this.onClick);
        this.track.addEventListener('scroll', this.onScroll, { passive: true });
        // Also the first measurement: an observer fires once on observe(), right after layout,
        // so the widths are read without forcing a layout while the page is being built.
        this.resizeObserver = new ResizeObserver(() => this.update());
        this.resizeObserver.observe(this.track);
      }

      disconnectedCallback() {
        this.prev?.removeEventListener('click', this.onClick);
        this.next?.removeEventListener('click', this.onClick);
        this.track?.removeEventListener('scroll', this.onScroll);
        this.resizeObserver?.disconnect();
        if (this.frame) cancelAnimationFrame(this.frame);
        this.frame = null;
      }

      get isRtl() {
        return getComputedStyle(this.track).direction === 'rtl';
      }

      step(direction) {
        const slide = this.track.querySelector('.upsell__slide');
        if (!slide) return;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        const distance = (slide.getBoundingClientRect().width + gap) * direction;
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.track.scrollBy({ left: this.isRtl ? -distance : distance, behavior: reduceMotion ? 'auto' : 'smooth' });
      }

      update() {
        const max = this.track.scrollWidth - this.track.clientWidth;
        const scrollable = max > 1;
        this.nav.hidden = !scrollable;
        if (!scrollable) return;
        const position = Math.abs(this.track.scrollLeft);
        this.prev.disabled = position <= 1;
        this.next.disabled = position >= max - 1;
      }
    }
  );
}
